module.exports = __webpack_public_path__ + "static/media/wave.92c14f68.svg";